import axios from 'axios'
import alert from '../libs/alert'
import MessageDialog from '../libs/message-dialog'

export default function (callback = () => {}) {
  if (process.env.NODE_ENV === 'production') {
    let state = {
      version: null,
      build: null
    }
    const process = () => axios
      .get(`/static/version.json?${Date.now()}`)
      .then(({ data }) => {
        try {
          const { version, build, messages } = data
          if (state.version === null) {
            callback(data)
          }
          if (state.version !== null && state.build !== null && state.build !== build) {
            callback(data)
            const buildVersion = build ? '(v' + build + ')' : ''
            const button = messages.length
              ? `
              <button type="button" class="show-changelog v-btn theme--light white grey--text text--darken-2" data-ripple="true">
                <div class="v-btn__content">
                  Changelog<i aria-hidden="true" class="icon icon--right theme--dark material-icons ml-1">history</i>
                </div>
              </button>`
              : ''
            alert.warn({
              title: `Dashboard was updated! ${buildVersion}`,
              timeout: false,
              emergency: true,
              message: `
                <div>Please reload this page to get latest version.</div>
                ${button}
              `,
              onOpening (config, e) {
                $(e).find('.show-changelog').on('click', () => {
                  // $(e).find('.iziToast-close').click()
                  setTimeout(() => {
                    MessageDialog.showMessage({
                      type: null,
                      title: `Changelog ${buildVersion}`,
                      html: messages.map(m => `<div>${m}</div>`).join(''),
                      confirmButtonText: 'Close',
                      customClass: 'pa-3',
                      onBeforeOpen (e) {
                        $(e).parent().css('z-index', 99999)
                        $(e).find('#swal2-content').css('text-align', 'left')
                      }
                    })
                  }, 300)
                })
              }
            })
          }
          state.version = version
          state.build = build
        } catch (e) {
          console.error(e)
        }
      })
      .catch(e => e)
    process()
    const intervalId = setInterval(process, 30 * 60 * 1000)
    return () => clearInterval(intervalId)
  }
}
